const articles = [
    {
        id: 2,
        title: 'Create a Custom Web Editor Using TypeScript, React, ANTLR, and Monaco-Editor | Part 2',
        link: 'https://bit.ly/2Yd9Nqr',
        timeToRead: 9,
        description: 'Part 2: Implement language services, auto-completion, syntax and semantic validation and auto-formatting',
        date: '01/06/2020',
        featuredimage: '/img/part 2.jpg'
    },
    {
        id: 1,
        title: 'Create a custom web editor using Typescript, React, ANTLR and Monaco-Editor | Part 1',
        link: 'https://bit.ly/2Um8uV4',
        timeToRead: 9,
        description: 'Part 1: Create a web editor with syntax colorization.',
        date: '01/01/2020',
        featuredimage: '/img/part 1.jpg'
    }
];

export default articles;